type GetWorkspaceAgentOnboardingPrefixScrollMarginParams = {
  prefix: HTMLElement | null;
  scrollContainer: HTMLElement | null;
};

/** Where the virtual list starts inside the scrollport, so rows below the scripted demo stay in range. */
export const getWorkspaceAgentOnboardingPrefixScrollMargin = ({
  prefix,
  scrollContainer,
}: GetWorkspaceAgentOnboardingPrefixScrollMarginParams): number => {
  if (!prefix || !scrollContainer) {
    return 0;
  }

  return Math.max(
    0,
    Math.round(
      prefix.getBoundingClientRect().bottom - scrollContainer.getBoundingClientRect().top + scrollContainer.scrollTop,
    ),
  );
};
